<template>
  <div class="row">
    <div class="form-group d-none d-md-block col">
      <div class="col-md-8 col-sm-12 py-0 px-0 mb-4">
        <el-date-picker type="daterange"
          class="ml-1 pr-2 w-100 form-control"
          id="dates"
          :value-format="valueFormat"
          :value="dates"
          @input="$emit('input' , $event)"
          unlink-panels
          :start-placeholder="startPlaceholder"
          :end-placeholder="endPlaceholder"
          required />
      </div>
    </div>
    <div class="form-group d-md-none col-sm-12">
      <div class="col-md-8 col-sm-12 py-0 px-0 mb-4 form-control">
        <el-date-picker type="date"
          class="ml-1 pr-2 w-100"
          :id="'startdate-${id}'"
          :value-format="valueFormat"
          v-model="startDate"
          :placeholder="startPlaceholder"
          required></el-date-picker>
      </div>

      <div class="col-md-8 col-sm-12 py-0 px-0 form-control">
        <el-date-picker type="date"
          class="ml-1 pr-2 w-100"
          :id="'enddate-${id}'"
          :value-format="valueFormat"
          v-model="endDate"
          :placeholder="endPlaceholder"
          required></el-date-picker>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'daterange-picker',
  props: ['value', 'valueFormat', 'id', 'startPlaceholder', 'endPlaceholder'],
  computed: {
    startDate: {
      get: function () { return this.value ? this.value[0] : null },
      set: function (value) { this.$emit('input', [value, this.value ? this.value[0] : value]) }
    },
    endDate: {
      get: function () { return this.value ? this.value[1] : null },
      set: function (value) { this.$emit('input', [this.value ? this.value[0] : value, value]) }
    },
    dates: {
      get: function () { return this.value },
      set: function (value) { this.$emit('input', value) }
    }
  }
}
</script>
